import { render, staticRenderFns } from "./greenPassport.vue?vue&type=template&id=f7e266e6"
import script from "./greenPassport.vue?vue&type=script&lang=js"
export * from "./greenPassport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports